import { useEffect, useRef, useState } from 'react'
import {
  reenviarEmail,
  register,
  validaNovaConta,
} from '../../components/api.ts'
import { Grid, TextField, CircularProgress, Button } from '@mui/material'
import { setSuccess } from '../../components/alerts.tsx'
import InputMask from 'react-input-mask'

export const NovaConta = ({ setTela, telaValidaToken, setTelaValidaToken }) => {
  const [dsNome, setDsNome] = useState('')
  const [dsEmail, setDsEmail] = useState('')
  const [nrDocumento, setNrDocumento] = useState('')
  const [dtNascimento, setDtNascimento] = useState(undefined)
  const [senha, setSenha] = useState('')
  const [token, setToken] = useState('')
  const inputs = useRef([])

  const handleInputChange = (index, event) => {
    const { value } = event.target
    if (/^[a-zA-Z0-9]*$/.test(value) && token.length <= 6) {
      const newToken = token.slice(0, index) + value + token.slice(index + 1)
      setToken(newToken.toUpperCase())

      if (value.length === 1 && index < 5) {
        inputs.current[index + 1].focus()
      }
    }
  }

  const handleBackspace = (index, event) => {
    const { value } = event.target
    if (value.length === 0 && index > 0) {
      inputs.current[index - 1].focus()
    }
  }

  const [loading, setLoading] = useState(false)

  const [timer, setTimer] = useState(0)

  useEffect(() => {
    let interval
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1)
      }, 1000)
    }
    return () => clearInterval(interval)
  }, [timer])

  const novaConta = async () => {
    setLoading(true)
    const response = await register(
      dsNome,
      dsEmail,
      nrDocumento.replace(/\D/g, ''),
      dtNascimento,
      senha,
    )
    if (response.status) {
      setTelaValidaToken({ open: true, idUsuario: response.idUsuario })
    }
    setLoading(false)
  }

  const validarToken = async () => {
    setLoading(true)
    const response = await validaNovaConta(telaValidaToken.idUsuario, token)
    if (response.status) {
      setTelaValidaToken(false)
      setTela('login')
    }
    setLoading(false)
  }

  const reenviaEmail = async () => {
    const response = await reenviarEmail(telaValidaToken.idUsuario)
    if (response.status) {
      setTimer(30)
      setSuccess('E-mail reenviado com sucesso')
    }
  }

  return telaValidaToken.open ? (
    <>
      <Grid item xs={12}>
        <span style={{ textAlign: 'justify' }}>
          Foi enviado um token de validação para seu e-mail.
        </span>
      </Grid>
      <Grid item xs={12} style={{ textAlign: 'center' }}>
        {[...Array(6)].map((_, index) => (
          <input
            key={index}
            ref={(input) => (inputs.current[index] = input)}
            type="text"
            maxLength="1"
            value={token[index] || ''}
            onChange={(event) => handleInputChange(index, event)}
            onKeyPress={(event) => handleBackspace(index, event)}
            className="m-1 h-16 w-16 rounded-md border-2 border-gray-600 text-center text-2xl font-bold transition-colors hover:border-primary-dark focus:border-primary-dark"
          />
        ))}
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          endIcon={loading ? <CircularProgress color="grey" size={15} /> : null}
          disabled={loading}
          onClick={validarToken}
        >
          Validar
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={timer > 0}
          onClick={reenviaEmail}
        >
          {timer > 0
            ? `Reenviar e-mail em ${timer} segundos`
            : 'Reenviar e-mail'}
        </Button>
      </Grid>
    </>
  ) : (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          margin="dense"
          label="Nome"
          autoFocus
          value={dsNome}
          onChange={(e) => setDsNome(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          margin="dense"
          label="Email"
          value={dsEmail}
          onChange={(e) => setDsEmail(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <InputMask
          mask="999.999.999-99"
          value={nrDocumento}
          onChange={(e) => setNrDocumento(e.target.value)}
        >
          {() => (
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              label="CPF"
            />
          )}
        </InputMask>
      </Grid>
      <Grid item xs={12}>
        <TextField
          InputLabelProps={{ shrink: true }}
          type="date"
          fullWidth
          variant="outlined"
          margin="dense"
          label="Data de Nascimento"
          value={dtNascimento}
          onChange={(e) => setDtNascimento(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type="password"
          fullWidth
          variant="outlined"
          margin="dense"
          label="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          endIcon={
            loading ? <CircularProgress color="inherit" size={15} /> : null
          }
          disabled={loading}
          onClick={novaConta}
        >
          Cadastrar
        </Button>
      </Grid>
    </>
  )
}
